import { isNil } from 'lodash';
import * as Shared from './shared-types';
import * as fetch from 'isomorphic-fetch';
import { Promise } from 'es6-promise';

export default abstract class FilterStoreBase<A extends {}, S extends {}> {

    protected _cache: Shared.IDictionary<S>;
    protected _endpoint: string;
    protected _pageSize: number;

    protected constructor(endpoint: string, pageSize: number) {
        this._cache = {};
        this._endpoint = endpoint;
        this._pageSize = pageSize;
    }

    public abstract getInitialState(): S;        
    protected abstract getCacheKey(action: A): string;
    protected abstract getRequestPayload(action: A): {}
    protected abstract parseStateData(stateData: any): S;
    
    public getUpdatedState(action: A): Promise<S> {

        return new Promise<S>((resolve, reject) => {
            
            const cacheKey = this.getCacheKey(action);
            if (isNil(this._cache[cacheKey])) {
                
                this.requestStateData(action)
                    .then((stateData: any) => {

                        const state = this.parseStateData(stateData);
                        this._cache[cacheKey] = stateData;
                        resolve(state);

                    }).catch((error: Error) => reject(error));

            } else {

                const stateData = this._cache[cacheKey];
                resolve(stateData);

            }

        });

    }

    private requestStateData(action: A): Promise<any> {

        return fetch(this._endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(this.getRequestPayload(action))
        })
        .then(this.checkStatus)
        .then((response: Response) => response.json());

    }

    private checkStatus(response: Response): Response {

        if (response.ok) {
            return response;
        }

        let error = new Error(`FilterStore.requestStateData: ${response.statusText}`);
        throw error;
    }

}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/base-filter-store.ts